export default "__VITE_ASSET__DeuIl6K9__"